<template>
  <div class="areas">
    <div class="row" v-for="(item, i) in value" :key="i">
      <Cascader
        :data="provinces"
        :load-data="cascaderLoadChildrenData"
        :value="valueList[i]"
        @on-change="(value) => onChange(i, value)"
        transfer
      ></Cascader>
      <Button
        v-if="max > 1"
        icon="md-trash"
        @click="removeCascader(i)"
        long
        class="remove-btn"
      />
    </div>

    <Button
      v-if="showAddButton"
      icon="md-add"
      @click="addCascader"
      long
      class="add-btn"
    />
  </div>
</template>
<style lang="stylus" scoped>
.areas
  .row
    width 100%
    display flex
    margin-bottom 10px

    .ivu-cascader-size-default
      flex auto

    .remove-btn
      flex 0 0 50px
      margin-left 10px
</style>
<script>
export default {
  props: ['value', 'max'],
  data() {
    return {
      valueModel: {},
      showAddButton: true,
      areasMap: ['provinceId', 'cityId', 'countyId'],
      provinces: [],
      valueList: [],
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (!newValue) return
        if (this.max && newValue.length >= this.max) {
          this.showAddButton = false
        } else {
          this.showAddButton = true
        }
        this.valueList = []
        newValue.forEach((item) => {
          let cascaderValue = []
          if ('provinceId' in item) cascaderValue.push(item.provinceId)
          if ('cityId' in item) cascaderValue.push(item.cityId)
          if ('countyId' in item) cascaderValue.push(item.countyId)
          this.valueList.push(cascaderValue)
        })
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.areasMap.forEach((item) => {
      if (item in this.value[0]) {
        this.valueModel[item] = ''
      }
    })
    this.$store.state.provinces.forEach((item) => {
      this.provinces.push({
        label: item.value,
        value: item.key,
        loading: false,
        children: [],
      })
    })
  },
  methods: {
    addCascader() {
      this.$emit('input', [
        ...this.value,
        JSON.parse(JSON.stringify(this.valueModel)),
      ])
    },
    removeCascader(i) {
      if (this.value.length === 1)
        return this.$Message.warning('至少需要1个地区')
      this.$delete(this.value, i)
    },
    cascaderLoadChildrenData(item, callback) {
      // console.log(item)
      const valueArray = item.__value.split(',')
      item.loading = true
      if (valueArray.length === 1) {
        // 点击第一级
        this.$axios.get(`/region/${item.value}/cities`).then((data) => {
          data.forEach((_item) => {
            let childrenItem = {
              label: _item.value,
              value: _item.key,
              loading: false,
              children: [],
            }
            if (Object.entries(this.valueModel).length === 2)
              delete childrenItem.loading
            item.children.push(childrenItem)
          })
          item.loading = false
          callback()
        })
      } else {
        // 点击第二级
        this.$axios
          .get(`/region/${item.__value.split(',')[1]}/countries`)
          .then((data) => {
            data.forEach((_item) => {
              item.children.push({
                label: _item.value,
                value: _item.key,
              })
            })
            item.loading = false
            callback()
          })
      }
    },
    onChange(i, value) {
      value.forEach((item, index) => {
        this.value[i][this.areasMap[index]] = item
      })
    },
  },
}
</script>
